import { applicationStore } from '@/store/application'

export default defineNuxtRouteMiddleware((to, from) => {
  const appStore = applicationStore()
  appStore.setSignupModalIsOpen(false)
})
